module.exports = __webpack_public_path__ + "img/em-tao-01.ee1f10f5.jpg";